import { Navigate, Outlet } from "react-router-dom";
import { ensureFeatureSwitchesLoaded, useFeatureSwitchState } from "@/features/feature-switches/featureSwitchSession";
import { useEffect } from "react";

export default function FeaturesRoute(props: { feature: "programsPortfolios" }) {
  useEffect(() => {
    ensureFeatureSwitchesLoaded();
  }, []);
  const state = useFeatureSwitchState("portfolios");
  if (props.feature === "programsPortfolios" && state === "pending") return null;
  if (props.feature === "programsPortfolios" && state !== "on") {
    // Phase 4.7: bypass retired /home; inbox is the canonical landing.
    return <Navigate to="/inbox" replace />;
  }
  return <Outlet />;
}
